import Trigger_Entity from "./trigger";
export default class Trigger extends Trigger_Entity {
  static fromList(triggersJSON: unknown): Array<Trigger> {
    const triggers: Trigger[] = [];
    if (triggersJSON)
      Array.isArray(triggersJSON) &&
        triggersJSON.forEach((triggerJSON) => {
          triggers.push(new Trigger(triggerJSON));
        });
    return triggers;
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
